import { render, staticRenderFns } from "./Delivery_date.vue?vue&type=template&id=15887d02"
import script from "./Delivery_date.vue?vue&type=script&lang=js"
export * from "./Delivery_date.vue?vue&type=script&lang=js"
import style0 from "./Delivery_date.vue?vue&type=style&index=0&id=15887d02&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports